<template>
  <nav class="nav-bar">
    <ul v-if="linked">
      <li class="nav-item" v-for="item in items">
        <a :href="item.route + item.anchor">{{item.title}}</a>
      </li>
    </ul>
    <ul v-else>
      <li class="nav-item" v-for="item in items">
        <a href="#" v-scroll-to="item.anchor">{{item.title}}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    linked: false
  },

  data() {
    return {
      items: [
        {
          title: 'Mission',
          anchor: '#mission',
          route: '/'
        },
        {
          title: 'Projects',
          anchor: '#projects',
          route: '/'
        },
        {
          title: 'Donate',
          anchor: '#donate',
          route: '/'
        },
        {
          title: 'Get in Touch',
          anchor: '#get-in-touch',
          route: '/'
        }
      ]
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/ui/MainNav.vue